module.exports = __webpack_public_path__ + "static/Carpool-redesign-new-0e229d4e8203cf3300de3c921324c817.gif";